import { Field, FieldProps } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';

import { useNotificationChannel } from '../useNotificationChannel';

import { ChannelFieldsProps } from './types';

export function SlackChannelFields({ index }: ChannelFieldsProps) {
  const channel = useNotificationChannel(index);

  return (
    <div className="space-y-3">
      <Field name={`notificationChannels.${index}.config.name`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="Name"
            size="vertical"
            inputId={`slack-name-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`slack-name-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="Slack Alerts"
              data-cy={`slack-name-${channel.id}`}
              className="w-full"
            />
          </FormControl>
        )}
      </Field>
      <Field name={`notificationChannels.${index}.config.api_url`}>
        {({ field, meta }: FieldProps<string>) => (
          <FormControl
            label="Webhook URL"
            size="vertical"
            inputId={`slack-webhook-url-${channel.id}`}
            errors={meta.touched ? meta.error : undefined}
            required
          >
            <Input
              id={`slack-webhook-url-${channel.id}`}
              name={field.name}
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="https://hooks.slack.com/services/..."
              data-cy={`slack-webhook-url-${channel.id}`}
              className="w-full"
            />
            <p className="text-gray-500 th-dark:text-gray-400 mt-1 text-xs">
              More info about configuring Webhooks on:{' '}
              <a
                href="https://docs.slack.dev/messaging/sending-messages-using-incoming-webhooks/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://docs.slack.dev/messaging/sending-messages-using-incoming-webhooks/
              </a>
            </p>
          </FormControl>
        )}
      </Field>
    </div>
  );
}
